<template>
  <div data-testid="beta-banner" class="p-1 text-center text-sm text-warning bg-warning/10">
    <strong>You're using our new applicant portal (beta).</strong>
    If something doesn't look right, email
    <a href="mailto:admissions@cambridgespark.com">admissions@cambridgespark.com</a>
    and we'll help.
  </div>
</template>

<script>
export default {
  name: 'BetaBanner',
};
</script>
